<div class="p-24">
  <h2 class="mat-h3">Bot UI configuration</h2>
  <p class="mat-body-1">
    When enabled, the chat experience uses each bot's UI configuration (welcome text, layout, quiz behaviour,
    etc.). You can turn this on here without changing deployment environment files.
  </p>
  <p class="mat-body-2 hint">
    If you have never saved this setting, the app follows the deployment default
    @if (deploymentFallbackEnabled()) {
      <span>(currently on).</span>
    } @else {
      <span>(currently off).</span>
    }
  </p>

  <mat-slide-toggle
    [checked]="botUiConfigEnabled()"
    (change)="onToggleChange($event)"
    aria-label="Enable bot UI configuration"
  >
    Use bot UI configuration in chat
  </mat-slide-toggle>
</div>
